import * as React from "react";
import { Divider, Hidden, Stack } from "@origin-digital/ods-core";
import { QuickLinksController } from "../components/QuickLinks";
import content from "../cms/searchbar.json";
import { IAppContext } from "../AppContext";
import { LoginViewMessagesController } from "../components/LoginViewMessages";
import { ScreenTemplate } from "./ScreenTemplate";

interface IProps {
  context: IAppContext;
}

export const Home = ({ context }: IProps) => (
  <ScreenTemplate
    title={content.title}
    description={content.text}
    isNative={context.isNative}
    isHome={true}
    data-id="home"
  >
    <Stack space={["large", "xlarge"]}>
      <QuickLinksController />
      {!context.isNative && (
        <Hidden above="md">
          <Stack space={["large", "xlarge"]}>
            <LoginViewMessagesController />
            <Divider />
          </Stack>
        </Hidden>
      )}
    </Stack>
  </ScreenTemplate>
);
